import { render, staticRenderFns } from "./TasksAgGrid.vue?vue&type=template&id=18581262"
import script from "./TasksAgGrid.vue?vue&type=script&lang=js"
export * from "./TasksAgGrid.vue?vue&type=script&lang=js"
import style0 from "./TasksAgGrid.vue?vue&type=style&index=0&id=18581262&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports